/**
 * @param {Object} [relativeCutOffTime]
 * @param {string} [relativeCutOffTime.pickupRelativeDay]
 * @returns {string}
 */
export const relativeDayUpper = (relativeCutOffTime) => relativeCutOffTime?.pickupRelativeDay?.toUpperCase() || 'NA';
